import { PillVariants, PillVariantsMapper, PillVariantsValue } from './constants';

import s from './Pill.module.css';

interface PillProps {
  children: React.ReactNode;
  variant: PillVariantsValue;
}
const Pill = ({ children, variant = PillVariants.PURPLE }: PillProps) => {
  return (
    <div className={s.pill} style={PillVariantsMapper[variant]}>
      {children}
    </div>
  );
};

export default Pill;
